import {makeStyles, Typography} from '@material-ui/core';
import {FormattedMessage} from 'react-intl';

const useStyles = makeStyles((theme) => ({
  header: {
    padding: `${theme.spacing(3)}px 0 0 ${theme.spacing(1)}px`,
    marginBottom: theme.spacing(2),
    borderBottom: `2px solid ${theme.palette.primary.main}`,
    width: '100%',
  },
}));

export default ({label, values, num, h, children}) => {
  const classes = useStyles();
  return (
    <div className={classes.header}>
      <Typography variant="h5" component={h || 'h3'}>
        {children ? children : <FormattedMessage {...label} values={{values}}/>}
        {num && ` ${num}`}
      </Typography>
    </div>
  );
};
